import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      loans: [],
      loading: false,

      order: 'amount',
      orderList: [
        {
          label: '금리 낮은 순',
          value: 'rate',
        },
        {
          label: '한도 높은 순',
          value: 'amount',
        },
      ],
    }
  },

  watch: {
    order() {
      this.sortLoans()
    },
  },

  computed: {
    ...mapState('loanMarketplace', ['loanOffers']),
  },

  methods: {
    async fetchItems() {
      this.loading = true
      try {
        // 이전 페이지에서 데이터 받아서 들어오는걸로 변경됨
        const data = this.loanOffers

        this.loans = data
        this.sortLoans()
      } finally {
        this.loading = false
      }
    },

    sortLoans() {
      if (this.order === 'amount') {
        // 한도 높은 순, 금리 낮은 순
        this.multiFieldSort(this.loans, [{ maxLoanAmount: -1 }, { minInterestRate: 1 }])
      } else if (this.order === 'rate') {
        // 금리 낮은 순, 한도 높은 순
        this.multiFieldSort(this.loans, [{ minInterestRate: 1 }, { maxLoanAmount: -1 }])
      }

      return this.loans
    },

    /**
     * 여러 필드를 기준으로 정렬
     *
     * @param {*} arr
     * @param {*} criteria [{필드명: 순서(오름차순: 1, 내림차순: -1)}, ...]
     * @returns
     */
    multiFieldSort(arr, criteria) {
      arr.sort(function (a, b) {
        for (const criterion of criteria) {
          const field = Object.keys(criterion)[0]
          const order = criterion[field]

          if (a[field] < b[field]) {
            return -1 * order
          } else if (a[field] > b[field]) {
            return 1 * order
          }
        }

        return 0
      })

      return arr
    },
  },
}
